import type { ReactNode } from 'react';
import { firstMvp } from '@/lib/productScope';
import DemoToaster from './DemoToaster';
import BrandPanel from './BrandPanel';
import LocaleSync from '@/i18n/LocaleSync';

/** Full-viewport desktop scenery behind the centered brand/app group. */
export default function AppFrame({ children }: { children: ReactNode }) {
  return (
    <>
      <div className="relative isolate min-h-dvh bg-gp-pink-50">
        <div
          aria-hidden="true"
          className="gp-desktop-backdrop pointer-events-none fixed inset-0 -z-10 hidden lg:block"
        >
          <img
            src="/images/seoul-glow-panorama.webp"
            width={1536}
            height={864}
            alt=""
            loading="lazy"
            className="size-full object-cover"
          />
          <div className="absolute inset-0 bg-linear-to-r from-gp-pink-50/65 via-gp-pink-50/35 to-gp-pink-50/15" />
        </div>
        <div className="flex min-h-dvh lg:mx-auto lg:max-w-[1120px] lg:gap-8 lg:px-8">
          <LocaleSync>
            <BrandPanel />
            <div
              data-app-frame
              className="relative mx-auto flex min-h-dvh w-full max-w-app flex-col bg-gp-pink-50 [--gp-bottom-nav-height:0px] [--gp-bottom-nav-overhang:0px] lg:mx-0 lg:shadow-[0_0_40px_rgba(43,36,36,0.08)]"
            >
              {children}
            </div>
          </LocaleSync>
        </div>
      </div>
      {!firstMvp && <DemoToaster />}
    </>
  );
}
